<template>
  <div class="droppable-resumable-uploader">
    <ResumableUploadWrapper
      v-slot="{ uploading, percentage, errors, message, fileIndex, retry }"
      :files="files"
      :upload-url="uploadUrl"
      @upload-done="emitUploadResponses"
    >
      <DroppableFileSelector
        ref="droppableFileSelector"
        :accept="accept"
        :disabled="disabled"
        v-bind="$attrs"
        @change="setFiles"
      >
        <UploadFailureView
          v-if="message || errors.length"
          class="droppable-resumable-uploader__failure-view"
          :file-name="files[fileIndex].name"
          :message="message"
          :errors="errors"
          @retry="retry"
          @cancel="resetAndCancel"
        />

        <div
          v-else-if="uploading"
          class="droppable-resumable-uploader__progress-wrp"
        >
          <ElProgress
            :key="fileIndex"
            class="droppable-resumable-uploader__progress"
            color="#0EA960"
            :width="100"
            :stroke-width="7"
            :percentage="percentage"
            :status="percentage === 100 ? 'success' : null"
          />

          <p>
            {{
              $t('DROPPABLE_UPLOADER.UPLOADING_FILE_INDEX', {
                current: fileIndex + 1,
                total: files.length,
              })
            }}
          </p>

          <ElButton
            type="text"
            size="mini"
            icon="el-icon-close"
            class="droppable-resumable-uploader__cancel"
            @click.stop="resetAndCancel"
          >
            {{ $t('DROPPABLE_UPLOADER.CANCEL_UPLOAD') }}
          </ElButton>
        </div>
      </DroppableFileSelector>
    </ResumableUploadWrapper>
  </div>
</template>

<script>
import DroppableFileSelector from '@@/common/file-selectors/DroppableFileSelector';
import ResumableUploadWrapper from '@@/common/file-uploaders/ResumableUploadWrapper';
import UploadFailureView from './UploadFailureView';

export default {
  name: 'DroppableResumableUploader',

  components: {
    DroppableFileSelector,
    ResumableUploadWrapper,
    UploadFailureView,
  },

  props: {
    accept: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: [String, Function],
      required: true,
    },
    filesFilterFunction: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      files: [],
    };
  },

  methods: {
    setFiles(files) {
      if (this.filesFilterFunction) {
        this.files = this.filesFilterFunction(files);
      } else {
        this.files = files;
      }
    },

    emitUploadResponses(responses) {
      this.$emit('upload-done', responses, this.files);
    },

    resetAndCancel() {
      this.files = null;
      this.$refs.droppableFileSelector?.reset();
    },
  },
};
</script>

<style lang="scss">
.droppable-resumable-uploader {
  &__failure-view {
    margin: $global-margin 0;
  }

  &__progress-wrp {
    width: 90%;
  }

  &__cancel {
    color: $lb-color-alert;

    &:focus,
    &:hover {
      color: $lb-color-alert;
    }
  }

  &__progress {
    max-width: 450px;
    display: flex;
    justify-content: space-between;
    direction: ltr;
    text-align: left;
    padding: 0 10px;
    margin: $global-margin / 2 auto;

    .el-progress-bar {
      padding: 0;
      margin: 0;
    }

    .el-progress-bar__inner {
      background-color: $--color-info;

      &.is-success {
        background-color: $lb-color-primary;
      }
    }
  }
}
</style>
